// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3zyT4","col":"Table_col__1qhGd","fulfillmentStatus":"Table_fulfillmentStatus__h0aJX","emailCol":"Table_emailCol__bgJ6K"};